export default __webpack_public_path__ + "static/media/Nunito-LightItalic.1900c5fd.woff2";